// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__30SVg","additionalInfo":"AgreementModal_additionalInfo__idPSi"};